import {
  CloudFog,
  CloudLightning,
  CloudRain,
  CloudSnow,
  CloudSun,
  Sun,
  type LucideIcon,
} from "lucide-react";

export function getWeatherIcon(condition?: string): LucideIcon {
  const normalized = (condition || "").toLowerCase();

  if (normalized.includes("thunder")) return CloudLightning;
  if (normalized.includes("snow")) return CloudSnow;
  if (
    normalized.includes("rain") ||
    normalized.includes("drizzle") ||
    normalized.includes("shower")
  ) {
    return CloudRain;
  }
  if (normalized.includes("fog")) return CloudFog;
  if (normalized.includes("cloud")) return CloudSun;

  return Sun;
}